var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "modal", staticClass: "modal" }, [
    _c(
      "div",
      { staticClass: "modal__wrapper" },
      [
        _c(
          "v-row",
          { staticClass: "modal__wrapper-row", attrs: { variant: "flex" } },
          [
            _c(
              "v-column",
              { staticClass: "modal__wrapper-column", attrs: { large: 12 } },
              [
                _vm.headerHeight
                  ? _c(
                      "div",
                      {
                        ref: "modalHeader",
                        staticClass: "modal__header",
                        style: {
                          height: _vm.headerHeight + "px"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "header__logo",
                            attrs: { to: _vm.path("index") }
                          },
                          [_c("v-icon", { attrs: { name: "logo/blue" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-button",
                          {
                            staticClass: "modal__close",
                            attrs: {
                              to: {
                                query: {
                                  modal: undefined
                                }
                              },
                              size: "small",
                              variant: "secondary"
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("button.modalClose")) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { ref: "modalInner", staticClass: "modal__inner" }, [
                  _c(
                    "div",
                    { staticClass: "modal__content" },
                    [
                      _vm.slug === _vm.$t("routes.getApp.modalName")
                        ? [_c("v-send-app")]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.slug === _vm.$t("routes.cards.modalName")
                        ? [_c("v-signpost")]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.slug === _vm.$t("routes.user.language.modalName")
                        ? [
                            _c("v-lang-switch", {
                              attrs: {
                                styles: {
                                  marginTop: "-" + _vm.headerHeight / 2 + "px"
                                }
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.slug === _vm.$t("routes.contact.modalName")
                        ? [_c("v-contact-form")]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }